import {IComponentController} from "angular";
import "../../../styles/opportunity-selector.scss";
import {OpportunitySetting} from "modules/user_settings/model/enums/enums";

export class OpportunitySelector implements IComponentController {
    public selectedOpportunity: OpportunitySetting;
    public opportunityList: Array<OpportunitySetting>;
    public onOpportunitySelect: (args: { opportunity: OpportunitySetting }) => void;

    public static instance = {
        controller: OpportunitySelector,
        template: require('./opportunity-selector.html'),
        bindings: {
            selectedOpportunity: '=',
            onOpportunitySelect: '&',
        }
    };

    constructor() {
        this.opportunityList = Object.values(OpportunitySetting);
    }

    $onInit(): void {
        if (!this.selectedOpportunity) {
            this.selectedOpportunity = OpportunitySetting.RATE_CALCULATOR;
        }
    }

    selectOpportunity(opportunity: OpportunitySetting): void {
        this.selectedOpportunity = opportunity;
        if (this.onOpportunitySelect) {
            this.onOpportunitySelect({opportunity});
        }
    }
}
